import { render, staticRenderFns } from "./GestionCategorias.vue?vue&type=template&id=6fca93ec"
import script from "./GestionCategorias.vue?vue&type=script&lang=js"
export * from "./GestionCategorias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports